module.exports = __webpack_public_path__ + "img/device_1001_1_select.5a34c428.svg";